import {
  UseReflectionCategoryPageDataArgs,
  UseReflectionCategoryPageDataReturn,
} from "./types";
import {
  filterEntriesByModule,
  filterTestSets,
  groupTestSetsByCubeSide,
  filterDynamicTestSetsByEntriesSession,
} from "../../utils";
import { Module } from "../../../../../constants";
import { CUBE_SIDE_NAMES } from "./../../components/Сube/constants";
import {
  filterDynamicTestSetsByCategoryAndSide,
  buildReflectionCubeSideData,
} from "./utils";

export function useReflectionCategoryPageData({
  rawData,
  selectedFilters,
  currentTestId,
  category,
}: UseReflectionCategoryPageDataArgs): UseReflectionCategoryPageDataReturn {
  const allTestSets = rawData?.testSets ?? [];
  const reflectionEntries = filterEntriesByModule(
    rawData?.allEntries ?? [],
    Module.Reflection,
    selectedFilters
  );

  const dynamicTestSets = filterDynamicTestSetsByEntriesSession(
    rawData?.dynamicTestSets ?? [],
    reflectionEntries,
    Module.Reflection
  );

  const currentTest = rawData?.tests.find(t => t._id === currentTestId);
  const reflectionTestSets = filterTestSets(allTestSets, {
    module: Module.Reflection,
    testId: currentTestId,
  });
  const leveragesTemplateTestSet = reflectionTestSets.find(
    ts => ts.spreadsheetId === currentTest?.module2SheetIds[0]
  );
  const challengesTemplateTestSet = reflectionTestSets.find(
    ts => ts.spreadsheetId === currentTest?.module2SheetIds[1]
  );

  const categoryTestSets = filterTestSets(allTestSets, {
    category,
  });
  const currentTestAndCategoryTestSets = filterTestSets(categoryTestSets, {
    testId: currentTestId,
  });
  const categoryTestSetIds = categoryTestSets.map(ts => ts._id);
  const testSetsByCubeSide = groupTestSetsByCubeSide(
    currentTestAndCategoryTestSets
  );

  return CUBE_SIDE_NAMES.reduce((acc, cubeSide) => {
    const dynamicTestSetsForSide = filterDynamicTestSetsByCategoryAndSide(
      dynamicTestSets,
      cubeSide,
      categoryTestSetIds
    );

    const reflectionEntriesIds = reflectionEntries
      .filter(
        e =>
          dynamicTestSetsForSide.some(dts => dts._id === e.testSetId)
      )
      .map(e => e._id);

    acc[cubeSide] = buildReflectionCubeSideData(
      cubeSide,
      testSetsByCubeSide[cubeSide]?.[0],
      reflectionEntriesIds,
      leveragesTemplateTestSet,
      challengesTemplateTestSet,
      dynamicTestSetsForSide,
      dynamicTestSets.length
    );

    return acc;
  }, {} as UseReflectionCategoryPageDataReturn);
}
